<template>
  <input
    type="text"
    class="tg-date-picker--control"
    :class="{ active: isActive }"
  />
</template>

<script>
import $ from "jquery";

export default {
  name: "TgDatePicker",
  computed: {
    // RM20260715103 時分篩選：showTime 時格式擴充到分
    dateFormat() {
      return this.showTime ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD";
    },
    localeInfo() {
      if (["zh-cn", "zh-hk"].includes(this.$store.state.app.lang.key)) {
        return {
          format: this.dateFormat,
          daysOfWeek: ["日", "一", "二", "三", "四", "五", "六"],
          monthNames: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月",
          ],
          year: "年",
        };
      } else {
        return {
          format: this.dateFormat,
          separator: " - ",
          applyLabel: "Apply",
          cancelLabel: "Cancel",
          fromLabel: "From",
          toLabel: "To",
          customRangeLabel: "Custom",
          weekLabel: "W",
          daysOfWeek: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
          monthNames: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ],
          firstDay: 1,
          year: "",
        };
      }
    },
  },
  mounted: function () {
    let self = this;
    $(this.$el)
      .daterangepicker({
        singleDatePicker: true,
        showDropdowns: true,
        autoApply: true,
        locale: this.localeInfo,
        // RM20260715103 時分篩選：timePicker 模式（daterangepicker 於 timePicker 時會顯示套用鈕）
        ...(this.showTime
          ? { timePicker: true, timePicker24Hour: true, timePickerIncrement: 1 }
          : {}),
        ...(this.options || {}),
      })
      .on("apply.daterangepicker", function (ev, picker) {
        self.$emit("input", picker.startDate.format(self.dateFormat));
      })
      .on("show.daterangepicker", function (ev, picker) {
        // 時分模式：daterangepicker 將時分下拉放在預設隱藏的 .daterangepicker_input 內，
        // 加上專屬 class 由 CSS 放行，避免影響其他未啟用時分的日期選擇器
        if (self.showTime && picker && picker.container) {
          picker.container.addClass("tg-datepicker--with-time");
        }
        self.isActive = true;
      })
      .on("hide.daterangepicker", () => {
        this.isActive = false;
      });
    // 因為daterangepicker會有預設值，故同步給予vue component預設值
    self.$emit("input", $(this.$el).val());
  },
  beforeDestroy: function () {
    $(this.$el).daterangepicker("remove");
  },
  props: ["value", "options", "showTime"],
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    input(value) {
      $(this.$el).val(value);
    },
    active(bool = true) {
      this.isActive = bool;
    },
  },
  watch: {
    value(value) {
      // 將props 的值傳遞給 jQuery's DOM
      $(this.$el).val(value);

      // 同步至 daterangepicker 實例。只設 DOM 值時實例內部仍是舊日期／時分，
      // 使用者操作日曆後 Apply 會用內部值覆蓋顯示值
      // （例：結束時間 23:59 於選日期後被改回 00:00）
      const picker = $(this.$el).data("daterangepicker");
      if (picker && value && !this.isActive) {
        picker.setStartDate(value);
        picker.setEndDate(value);
      }
    },
  },
};
</script>
